const MediaQueries = {
  mobileMedia: window.matchMedia('screen and (max-width: 767px)'),
  tabletMedia: window.matchMedia(
    'screen and (min-width: 768px) and (max-width: 991px)'
  ),
  desktopMedia: window.matchMedia('screen and (min-width: 992px)'),
  xs: window.matchMedia('screen and (max-width: 575px)'),
  sm: window.matchMedia('screen and (min-width: 576px) and (max-width: 767px)'),
  md: window.matchMedia('screen and (min-width: 768px) and (max-width: 991px)'),
  lg: window.matchMedia(
    'screen and (min-width: 992px) and (max-width: 1199px)'
  ),
  xl: window.matchMedia('screen and (min-width: 1200px)'),
};

export default MediaQueries;
